import React from "react";

class MaterialPopoverContent extends React.Component {
  render() {
    return this.props.children;
  }
}

export default MaterialPopoverContent;
